/**
 * Shared live-price Y selection + continuous CSS Y projection.
 * One gate for body tip / dashed line / gold chip so LOG futures stay aligned.
 */
import { mcapToY, latticeRowIndex } from './chartUtils'

/**
 * Shared live close vs highlight gate (LOG-aware ±2 rows).
 * Returns the price body tip, dashed line, and chip must all use.
 */
export function resolveLivePriceForY({ highlightMcap, closeMcap, sortedMcaps, bucketSize, lnStep }) {
  const hl = +highlightMcap || 0
  const cM = +closeMcap || 0
  if (!(hl > 0 && cM > 0)) return hl > 0 ? hl : cM
  const ok = sortedMcaps?.log
    ? Math.abs(Math.log(hl / cM)) <= ((lnStep > 0 ? lnStep : Math.log(1.01)) * 2)
    : Math.abs(hl - cM) <= (bucketSize > 0 ? bucketSize : 0) * 2
  return ok ? hl : cM
}

/** Thin wrapper around mcapToY — single import point for continuous Y. */
export function priceToCssY(mcap, sortedMcaps, rowHeight) {
  return mcapToY(mcap, sortedMcaps, rowHeight)
}

/** Overlay Y: centre of the row whose CELL holds this price (bucket
 *  membership, same as footprint cells). Nearest-key picked the row above
 *  for any price in the upper half of its bucket. */
export function overlayMcapToY(mcap, sortedMcaps, rowHeight) {
  if (!sortedMcaps || sortedMcaps.length < 2 || !(rowHeight > 0)) return 0
  const row = latticeRowIndex(sortedMcaps, mcap)
  if (row < 0 || row >= sortedMcaps.length) return mcapToY(mcap, sortedMcaps, rowHeight)
  return row * rowHeight + rowHeight / 2
}
